/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import IdentityModel from 'cio/models/identity';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import DS from 'ember-data';

interface TwilioIdentitiesAddArgs {
  toggleAdding: () => unknown;
}

export default class TwilioIdentitiesAdd extends Component<TwilioIdentitiesAddArgs> {
  @service store!: DS.Store;

  @tracked identity: null | IdentityModel = null;

  constructor(owner: unknown, args: TwilioIdentitiesAddArgs) {
    super(owner, args);
    this.setupIdentity();
  }

  saveIdentity = task({ drop: true }, async () => {
    try {
      await this.identity?.save();
      this.args.toggleAdding();
    } catch {}
  });

  private setupIdentity() {
    this.identity = this.store.createRecord('identity', { templateType: 'twilio' });
  }

  @action
  discardChanges() {
    this.identity?.unloadRecord();
    this.args.toggleAdding();
  }
}
